import { render, staticRenderFns } from "./vipcheck.vue?vue&type=template&id=799b0f0d&scoped=true&"
import script from "./vipcheck.vue?vue&type=script&lang=js&"
export * from "./vipcheck.vue?vue&type=script&lang=js&"
import style0 from "./vipcheck.vue?vue&type=style&index=0&id=799b0f0d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b0f0d",
  null
  
)

export default component.exports